import React, { useEffect, useState } from "react";
import { Button, Input, Spinner } from "reactstrap";
import { Option } from "./style";
import { ProjectButton } from "../project/style";
import { CustomizationSpinnerContainer, Notification } from "../common/style";
import { editLight } from "./service";
import Select from "react-select";

const LightForm = (props) => {
  const [model, setModel] = useState(props.lightsList.light_types[0].value);
  const [offset, setOffset] = useState("");
  const [from, setFrom] = useState("front");
  const [onSide, setOnSide] = useState("inner");
  const [selectedSides, setSelectedSides] = useState([]);
  const [disableAction, setDisableAction] = useState(true);
  const [isRightPaneLoading, setIsRightPaneLoading] = useState(false);
  const [isNotificationVisible, setIsNotificationVisible] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState({});

  useEffect(() => {
    if (props.lightInfo.action === "update") {
      setModel(props.lightInfo.model);
      setOffset(props.lightInfo.offset);
      setFrom(props.lightInfo.from);
      setOnSide(props.lightInfo.onSide);
      setSelectedSides(props.lightInfo.selectedSides);
    }
  }, []);

  useEffect(() => {
    if (selectedSides.length > 0 && offset) setDisableAction(false);
    else setDisableAction(true);
  }, [selectedSides, offset]);

  const updateSides = (side) => {
    if (selectedSides.includes(side))
      setSelectedSides(
        selectedSides.filter((selectedSide) => selectedSide !== side)
      );
    else setSelectedSides([...selectedSides, side]);
  };

  const editGroove = () => {
    setIsRightPaneLoading(true);

    editLight({
      projectId: props.projectId,
      orderItemId: props.orderItemId,
      light: {
        action: props.lightInfo.action,
        uniq_id: props.lightInfo.uniqId,
        model,
        offset,
        from,
        on_side: onSide,
        sides: selectedSides,
      },
    })
      .then((orderItem) => {
        props.setShowLightForm(false);
        props.replaceModule(orderItem);
        props.refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({
          type: "danger",
          text: error,
        });
      })
      .finally(() => setIsRightPaneLoading(false));
  };

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  return (
    <>
      {notificationMessage.text && (
        <Notification
          color={notificationMessage.type}
          isOpen={isNotificationVisible}
          toggle={onDismissNotification}
        >
          {notificationMessage.text}
        </Notification>
      )}
      {isRightPaneLoading && (
        <CustomizationSpinnerContainer>
          <Spinner />
        </CustomizationSpinnerContainer>
      )}
      <div className={isRightPaneLoading ? "blurred" : ""}>
        <div className="info-header">
          <p className="fw-bold fs-14px m-0">{`${
            props.lightInfo.action === "add" ? "Add" : "Update"
          } Light`}</p>
          <i
            onClick={() => props.setShowLightForm(false)}
            className="fa-solid fa-close pointer fs-5"
          />
        </div>
        <div className="d-flex flex-column row-gap-3 p-3">
          <div>
            <p className="mb-1 grey_letter">Model</p>
            <Input
              className="fs-12px rounded-1 w-auto"
              type="select"
              value={model}
              onChange={(e) => setModel(e.target.value)}
            >
              {props.lightsList.light_types.map((e, index) => (
                <option value={e.value} key={index}>
                  {e.name}
                </option>
              ))}
            </Input>
          </div>
          <div>
            <p className="mb-1 grey_letter">Position</p>
            <div className="d-flex align-items-center column-gap-2">
              <Select
                className="w-75px"
                options={props.lightsList.light_offsets.map((offset) => ({
                  label: `${offset} mm`,
                  value: offset,
                }))}
                value={
                  props.lightsList.light_offsets
                    .map((offset) => ({ label: `${offset} mm`, value: offset }))
                    .find((e) => e.value == offset) || null
                }
                onChange={(e) => setOffset(e.value)}
              />
              <p className="m-0 grey_letter">from</p>
              <Input
                className="fs-12px rounded-1 w-auto"
                type="select"
                value={from}
                onChange={(e) => setFrom(e.target.value)}
              >
                <option value="front">front</option>
                <option value="back">back</option>
              </Input>
            </div>
          </div>
          <div>
            <p className="mb-1 grey_letter">Side</p>
            <div className="d-flex align-items-center column-gap-2">
              <Input
                className="fs-12px rounded-1 w-auto"
                type="select"
                value={onSide}
                onChange={(e) => setOnSide(e.target.value)}
              >
                <option value="inner">Inner</option>
                <option value="outer">Outer</option>
              </Input>
              <div className="rounded-0 btn-group">
                {["left", "right", "top", "bottom"].map((side) => {
                  return (
                    <Option
                      key={side}
                      className={`default-option text-capitalize ${
                        selectedSides.includes(side) ? "selected-option" : ""
                      }`}
                      onClick={() => updateSides(side)}
                    >
                      {side}
                    </Option>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex column-gap-3 border-top p-3">
          <ProjectButton
            className="px-4 rounded-1"
            disabled={disableAction}
            onClick={editGroove}
          >
            {props.lightInfo.action === "add" ? "Add" : "Update"}
          </ProjectButton>
          <Button
            className="rounded-1"
            outline
            onClick={() => props.setShowLightForm(false)}
          >
            Cancel
          </Button>
        </div>
      </div>
    </>
  );
};

export default LightForm;
